import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { SospHandler } from '../types'
import { name } from '../symbols'
import { CurrentRouteInfoSymbol, IPropsStore, IStructureAPI, Props, StructureAPI } from '@wix/thunderbolt-symbols'
import { ICurrentRouteInfo } from 'feature-router'
import { resolveSospOnPage } from '../sospApi'

export const SospSideEffect = withDependencies(
	[CurrentRouteInfoSymbol, StructureAPI, Props],
	(
		currentRouteInfo: ICurrentRouteInfo,
		structureApi: IStructureAPI,
		propsStore: IPropsStore
	): IModelUpdatesHandlersImplementor<SospHandler> => {
		return {
			featureName: name,
			handlers: {
				onSospConfigChanged: ({ pageConfig }) => {
					// waiting for structureApi to update before resolving sosp
					setTimeout(() => {
						const pageId = currentRouteInfo.getCurrentRouteInfo()?.pageId || ''
						resolveSospOnPage(pageId, pageConfig, structureApi, propsStore)
					}, 0)
				},
			},
		}
	}
)
